import * as Styled from './RatingStrip.styled';
import Text from '../../../../../ToolkitV2/Text/Text';
import { RatingStripProps } from './RatingStrip.typed';
import { SELLER_TYPE } from '../../../../../../api/types/searchPageApiTypes';

const RatingStrip = ({ dealer, seller, isGrid }: RatingStripProps) => {
  const noRatingText = 'No rating';
  if (dealer) {
    const { trusted, type, rating } = dealer;
    return (
      <Styled.Ratings
        forwardedAs={'div'}
        color={'GREY_DARKER'}
        size={isGrid ? 'B14' : 'M14'}
      >
        {!isGrid && trusted && (
          <Styled.TrustedDealerBadge
            role={'img'}
            aria-label={'Trusted Dealer Badge'}
            data-testid="shield-icon"
          />
        )}
        {!isGrid && type && (
          <Styled.UserType>
            {trusted && 'Trusted '}
            {type}
          </Styled.UserType>
        )}
        <Styled.Star
          role={'img'}
          aria-label={'Star'}
          data-testid="star-icon"
          $rating={Boolean(rating)}
          $gap={!isGrid}
        />
        <Text forwardedAs={'span'} color={'GREY_DARK'}>
          {rating ?? noRatingText}
        </Text>
      </Styled.Ratings>
    );
  } else if (seller) {
    const { type, rating } = seller;
    return (
      <Styled.Ratings
        forwardedAs={'div'}
        color={'GREY_DARKER'}
        size={isGrid ? 'B14' : 'M14'}
      >
        {!isGrid && type && (
          <Styled.UserType>{SELLER_TYPE[type]}</Styled.UserType>
        )}
        <Styled.Star
          role={'img'}
          aria-label={'Star'}
          data-testid="star-icon"
          $rating={Boolean(rating)}
          $gap={!isGrid}
        />
        <Text forwardedAs={'span'} color={'GREY_DARK'}>
          {rating ?? noRatingText}
        </Text>
      </Styled.Ratings>
    );
  }
  return null;
};

export { RatingStrip };
